import { useDispatch, useSelector } from 'react-redux';
import { leadNamesSelector } from '../../ecg/selectors/signal.selectors';
import { Ruler2dContainer } from '../../ruler2d/components/Ruler2dContainer';
import { Ruler2d } from '../../ruler2d/components/Ruler2d';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Plot } from '../contexts/plot.context';
import { Row } from '../contexts/row.context';
import { Strip } from '../contexts/strip.context';
import { TOP_PLOT_HEIGHT, ZOOM } from '../utils/graph.utils';
import { AxisContainer } from './AxisContainer';
import { EditableStrip } from './EditableStrip';
import { GainPickerContainer } from './GainPickerContainer';
import { GridContainer } from './GridContainer';
import { LeadButtons } from './LeadButtons';
import { ManualQrsBar } from './ManualQrsBar';
import { NoiseBar } from './NoiseBar';
import { PlotHeader } from './PlotHeader';
import { QRSCount } from './QrsCount';
import { QrsWaves } from './QrsWaves';
import { STRIP_EDITOR_WIDTH, StripEditor } from './StripEditor';
import { StripPosition } from './StripPosition';
import { WaveTags } from './WaveTags';
import { DefaultLeads } from './DefaultLeads';
import {
  RulerInfo,
  RULER_HEADER_HEIGHT,
} from '../../ruler/components/RulerInfo';
import { Tool } from '../../tool/utils/tool.utils';
import { PlotContainer } from './PlotContainer';
import { RulerContainer } from '../../ruler/components/RulerContainer';
import { Ruler } from '../../ruler/components/Ruler';
import { isRestingStripSelector } from '../../ecg/selectors/ecg.selectors';
import { setActiveTool } from 'features/tool/actions/tool.actions';

const ZOOM_PLOT_DURATION = 4_000; // 4s
export const ZOOM_STRIP_ID = `${ZOOM}-strip`;

export const ZoomPlot: React.FC = () => {
  const leads = useSelector(leadNamesSelector);
  const isRulerActive = useSelector(
    isToolActiveSelector(Tool.ruler, Tool.rulerAnchored),
  );
  const isRuler2DActive = useSelector(isToolActiveSelector(Tool.ruler2d));
  const isRestingStrip = useSelector(isRestingStripSelector);
  const dispatch = useDispatch();

  if (isRulerActive && isRestingStrip) {
    dispatch(
      setActiveTool({
        tool: null,
        meta: { history: false },
      }),
    );
  }

  return (
    <PlotContainer>
      <Strip id={ZOOM_STRIP_ID} duration={ZOOM_PLOT_DURATION} leads={leads}>
        <Plot>
          <PlotHeader offset={STRIP_EDITOR_WIDTH} height={RULER_HEADER_HEIGHT}>
            <RulerInfo />
          </PlotHeader>
          <PlotHeader offset={STRIP_EDITOR_WIDTH}>
            <WaveTags />
          </PlotHeader>
        </Plot>
        <Plot
          cursor={isRuler2DActive ? 'crosshair' : undefined}
          plotName='zoom'
          data-testid='zoom-plot'
        >
          <Row height={TOP_PLOT_HEIGHT}>
            <StripEditor>
              <GainPickerContainer />
            </StripEditor>
            <EditableStrip>
              <GridContainer />
              <StripPosition>
                <DefaultLeads colorLeads={true} />
                <QrsWaves />
                {isRestingStrip ? (
                  <Ruler2dContainer>
                    <Ruler2d />
                  </Ruler2dContainer>
                ) : (
                  <RulerContainer>
                    <Ruler />
                  </RulerContainer>
                )}
                <ManualQrsBar />
                <QRSCount />
              </StripPosition>
              <LeadButtons />
            </EditableStrip>
          </Row>
        </Plot>
        <Plot>
          <NoiseBar offset={STRIP_EDITOR_WIDTH} />
          <AxisContainer offset={STRIP_EDITOR_WIDTH} />
        </Plot>
      </Strip>
    </PlotContainer>
  );
};
